import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface BOGModalData {
  aiText:           string;
  bogSubtitle:      string;
  bogScore:         number;
  bogChartData:     number[];
  bottomPerformers: Array<{ name: string; pct: string }>;
  weTalkPoints:     number[];
  iSeePoints:       number[];
  ccPoints:         number[];
  chartMonths:      string[];
  coachingTopicsMap: Record<string, Array<{ label: string; pct: number }>>;
  iSeeTopicsMap:     Record<string, Array<{ label: string; pct: number }>>;
  ccTopicsMap:       Record<string, Array<{ label: string; pct: number }>>;
  engCountryMonths:    any[];
  engPrevYearMonths:   any[];
  engCurrentMonthName: string;
  engCurrentYear:      number;
  /** Unit mode shows only one Engagement Score chart (no Leadership/HSE split). */
  isUnitMode: boolean;
}

@Injectable({ providedIn: "root" })
export class BOGModalService {
  isOpen$    = new BehaviorSubject<boolean>(false);
  modalData$ = new BehaviorSubject<BOGModalData | null>(null);

  setData(data: BOGModalData): void {
    this.modalData$.next(data);
  }

  open(): void {
    this.isOpen$.next(true);
    const ionContent = document.querySelector("ion-content.dashboard-wrapper") as HTMLElement;
    if (ionContent) ionContent.style.setProperty("--overflow", "hidden");
  }

  close(): void {
    this.isOpen$.next(false);
    const ionContent = document.querySelector("ion-content.dashboard-wrapper") as HTMLElement;
    if (ionContent) ionContent.style.removeProperty("--overflow");
  }
}
